import * as React from 'react'
import './step-title.css'


export default class extends React.Component<any, any>{

    render(){
        if(this.props.show ==null || this.props.show == true){
            return (
                <div className="step-title col-12">
                    <h1>
                        { this.props.children }
                    </h1>
                </div>

            )
        }else{
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/step-title.tsx